const showMoreButtons = document.querySelectorAll('.adm-div-c63-show-toggle');
const section = document.querySelector('.adm-section-c63')
const showMoreText = section.dataset.showmore;
const showLessText = section.dataset.showless;
// const abbrTextDskHeight = '44px';
// const abbrTextTabHeight = '66px';
// const abbrTextMobHeight = 'auto';

const abbreviateText = (text, limit) => {
    const words = text.split(' ');
    let abbreviatedText = '';
    let charCount = 0;
    for (let i = 0; i < words.length; i++) {
        if (charCount + words[i].length <= limit) {
            abbreviatedText += words[i] + ' ';
            charCount += words[i].length + 1;
        } else {
            break;
        }
    }
    return abbreviatedText.trim() + '...';
}

// const assignAbbrTextHeight = () => {
//     if (window.innerWidth >= 840) {
//         console.log("DESKTOP");
//         return abbrTextDskHeight;
//     } else if (window.innerWidth >= 610) {
//         console.log("TABLET");
//         return abbrTextTabHeight;
//     } else {
//         console.log("MOBILE");
//         return abbrTextMobHeight;
//     }
// }

showMoreButtons.forEach((button) => {
    const cardContainer = button.parentElement;
    const cardBody = cardContainer.querySelector('.adm-div-c63-card-body');
    const cardBodyFullText = cardBody.innerHTML;
    const cardBodyAbbrText = abbreviateText(cardBodyFullText, 250);

    const cardBodyCta = cardContainer.querySelector('.adm-div-c63-cta');
    
    // CREATE DIV WITH ABBREVIATED CONTENT.
    const abbrTextDiv = document.createElement('div');
    abbrTextDiv.innerHTML = cardBodyAbbrText;
    abbrTextDiv.classList.add('adm-div-c63-card-body-text-abbr');
    
    // CREATE DIV WITH FULL CONTENT.
    const fullTextDiv = document.createElement('div');
    fullTextDiv.innerHTML = cardBodyFullText;
    fullTextDiv.classList.add('adm-div-c63-card-body-text-full', 'hide');

    // REMOVE CARDBODY CONTENT.
    cardBody.innerHTML = '';

    // INJECT DIV WITH ABBREVIATED CONTENT.
    cardBody.appendChild(abbrTextDiv);
    
    // INJECT DIV WITH FULL CONTENT.
    cardBody.appendChild(fullTextDiv);

    // GET INITIAL HEIGHTS OF ABBR AND FULL CONTENT DIVS.
    let abbrHeight = abbrTextDiv.scrollHeight;

    // RECALCULATE ABBRHEIGHT WHEN RESIZED.
    window.addEventListener('resize',() => {
        if (!abbrTextDiv.classList.contains('hide')) {
            abbrHeight = abbrTextDiv.scrollHeight;
            abbrTextDiv.style.height = 'auto';
        }
        if (!fullTextDiv.classList.contains('hide')) {
            fullTextDiv.style.height = 'auto';
        }
    })

    // IF LENGTH OF BODY TEXT 250 CHAR & BELOW BUT THERE'S A CTA BUTTON, SHOW THE BUTTON.
    if (cardBodyFullText.length <= 250 && cardBodyCta) {
        cardBodyCta.classList.remove('hide');
    }

    // IF LENGTH OF BODY TEXT ABOVE 250 CHAR, REVEAL 'SHOW MORE'.
    if (cardBodyFullText.length > 250) {
        button.classList.remove('hide');
        button.innerText = showMoreText;
        if (cardBodyCta) {
            cardBodyCta.classList.add('hide');
        }
    }
    
    button.addEventListener('click', () => {        
        // EXPAND
        if (fullTextDiv.classList.contains('hide')) {
            fullTextDiv.style.height = `${abbrHeight}px`;
            abbrTextDiv.classList.add('hide');
            fullTextDiv.classList.remove('hide');
            fullTextDiv.style.height = `${fullTextDiv.scrollHeight}px`
            button.innerText = showLessText;
            button.classList.add('full');
            if (abbrHeight === fullTextDiv.scrollHeight && cardBodyCta) {
                cardBodyCta.classList.remove('hide');
            } else if (cardBodyCta) {
                setTimeout(() => {
                    cardBodyCta.classList.remove('hide');
                }, 500);
            }
        }
        // COLLAPSE
        else if (abbrTextDiv.classList.contains('hide')) {
            abbrTextDiv.style.height = `${abbrHeight}px`;
            fullTextDiv.style.height = `${abbrHeight}px`;
            if (abbrHeight === fullTextDiv.scrollHeight) {
                abbrTextDiv.classList.remove('hide');
                fullTextDiv.classList.add('hide');
                if (cardBodyCta) {
                    cardBodyCta.classList.add('hide');
                }
                button.innerText = showMoreText;
                button.classList.remove('full');
            } else {
                if (cardBodyCta) {
                    cardBodyCta.classList.add('hide');
                }
                setTimeout(() => {
                    abbrTextDiv.classList.remove('hide');
                    fullTextDiv.classList.add('hide');
                    button.innerText = showMoreText;
                    button.classList.remove('full');
                }, 500);
            }
        }
    });    
});